import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {GROUP, GROUP_ERROR, GROUP_MAX_SIZE_FILE} from '../../../constants/LabelConstants';
import InputText from '../../../../../common/components/InputText';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import FileUploader from '../../../../../common/components/FileUploader';
import {
    BankAccountFormDispatchProps,
    BankAccountFormStateProps,
} from '../../../types/mx/containers';
import {BankAccountDataState} from '../../../types/mx/components';
import {BankAccountFile, BankAccountFileType} from '../../../types/mx/types';
import {isEmpty} from '../../../../../common/utils/ValidationUtils';
import {FileProps} from '../../../../../common/types/components';
import {DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES} from '../../../../../common/constants/MimeTypeConstants';
import {COMMON} from '../../../../../common/constants/LabelConstants';
import {GLOBAL} from '../../../../constants/LabelConstants';

class BankAccountView extends React.Component<BankAccountFormStateProps
    & BankAccountFormDispatchProps, BankAccountDataState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
    }

    onPressSave = () => {
        this.setState({showErrors: true}, this.checkData);
    }

    dispatchError = (field: any, cond: (field: any) => boolean,
                     dispatch: (field: any, error: string) => void, error) => {
        if (cond(field)) dispatch(field, error);
    }

    checkData = () => {
        const {
            accountNumber, bankSelected, beneficiaryName, clabe, onDropFileIdentification,
            dealerOfficialIdentificationFile, dealerAccountStatusFile, onDropFileAccount, formType, target,
            onChangeAccountNumber, onChangeBeneficiary, onChangeBank, onChangeClabe, onSave, groupId
        } = this.props;
        const fileOfficialId: BankAccountFile = dealerOfficialIdentificationFile.value;
        const fileStatus: BankAccountFile = dealerAccountStatusFile.value;
        const documentRequired: string = GROUP_ERROR.GROUP_DOCUMENTS_REQUIRED;
        const fieldRequired: string = GROUP_ERROR.GROUP_FIELD_REQUIRED;
        const bankRequired: string = GROUP_ERROR.GROUP_REQUIRED_BANK;

        if (this.formHasNotError()) return onSave(groupId, formType, target);
        this.dispatchError(bankSelected.value, val => val === null || isEmpty(val.value), onChangeBank, bankRequired);
        this.dispatchError(beneficiaryName.value, isEmpty, onChangeBeneficiary, fieldRequired);
        this.dispatchError(clabe.value, isEmpty, onChangeClabe, fieldRequired);
        this.dispatchError(fileOfficialId, (file: BankAccountFile) =>
            (file === null || isEmpty(file.name)), onDropFileIdentification, documentRequired);
        this.dispatchError(fileStatus, (file: BankAccountFile) =>
            (file === null || isEmpty(file.name)), onDropFileAccount, documentRequired);
        this.dispatchError(accountNumber.value, field => !/^\d+$/.test(field), onChangeAccountNumber,
            GROUP_ERROR.GROUP_INVALID_BANK_ACCOUNT);
    }

    toBankAccountFile = (file, type: BankAccountFileType): BankAccountFile => ({
        url: file.preview,
        mimeType: file.type,
        fileType: type,
        hasError: false,
        content: file,
        isUploaded: false,
        name: file.name,
        size: file.size,
        lastModified: file.lastModified
    })

    onDropFile = (files: FileList, type: BankAccountFileType, section: string, error: string) => {
        const isSizeAllowed: boolean = !!files[0] && files[0].size <= GROUP_MAX_SIZE_FILE;
        const newError: string = isSizeAllowed ? error : COMMON.FILE_SIZE_NOT_ALLOWED;
        const file: BankAccountFile = isSizeAllowed ? this.toBankAccountFile(files[0], type) : null;
        if (type === BankAccountFileType.DEALER_ACCOUNT_STATUS_TYPE) this.props.onDropFileAccount(file, newError);
        else this.props.onDropFileIdentification(file, newError);
    }

    toFileProps = (file: BankAccountFile, id: string): FileProps => ({
        id, fileName: file.name, mimeType: file.mimeType,
        originalUrl: file.url, compressUrl: file.url, thumbnailUrl: file.url
    })

    onDeleteFile = (id: string, type: BankAccountFileType) => {
        this.props.onDeleteFile(id, type, GROUP_ERROR.GROUP_DOCUMENTS_REQUIRED);
    }

    formHasNotError = () => {
        const {
            bankSelected, accountNumber, beneficiaryName, clabe,
            dealerAccountStatusFile, dealerOfficialIdentificationFile,
        } = this.props;

        return !!bankSelected.value.value && !!accountNumber.value && !!beneficiaryName.value && !!clabe.value
            && !!dealerAccountStatusFile.value && !!dealerOfficialIdentificationFile.value &&
            bankSelected.error === null && accountNumber.error === null && beneficiaryName.error === null &&
            clabe.error === null;
    }

    render() {
        const btnStyle: string = 'btn btn-link btn-form border-0 h-100 pb-2';
        const {
            onCancel, bankSelected, banksList, onChangeBank, accountNumber, onChangeAccountNumber,
            beneficiaryName, clabe, dealerAccountStatusFile, dealerOfficialIdentificationFile,
            onChangeBeneficiary, onChangeClabe
        } = this.props;
        const {showErrors} = this.state;

        const formHasNotError: boolean = this.formHasNotError();
        const bankAccountFileStatusAccount: BankAccountFile = !!dealerAccountStatusFile &&
            dealerAccountStatusFile.value;
        const bankAccountFileId: BankAccountFile = !!dealerOfficialIdentificationFile &&
            dealerOfficialIdentificationFile.value;
        const accountFile: FileProps[] = bankAccountFileStatusAccount ?
            [this.toFileProps(bankAccountFileStatusAccount, 'bankAccountFileStatusAccount')] : [];
        const identificationFile: FileProps[] = bankAccountFileId ?
            [this.toFileProps(bankAccountFileId, 'bankAccountFileId')] : [];
        return (
            <div className="col-12 px-0 pt-5 pb-0">
                <div className="row">
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_ACCOUNT_NUMBER_FIELD_TITLE}
                            id="postalCode"
                            required={true}
                            pattern={/^[0-9]+$/}
                            maxLength={15}
                            minLength={4}
                            hasError={showErrors}
                            labelError={accountNumber.error}
                            value={accountNumber.value}
                            onChange={onChangeAccountNumber}/>
                    </div>
                    <div className="col">
                        <SelectSearchComponent
                            customClass="no-min-height"
                            id="documentTypes"
                            label={GROUP.GROUP_BANK_TITLE}
                            placeholder={GLOBAL.SELECT}
                            value={bankSelected.value}
                            data={banksList}
                            required={true}
                            insertInput={true}
                            onChange={onChangeBank}
                            hasError={showErrors}
                            labelError={bankSelected.error}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_BENEFICIARY_NAME_TITLE}
                            id="postalCode"
                            required={true}
                            minLength={3}
                            hasError={showErrors}
                            labelError={beneficiaryName.error}
                            value={beneficiaryName.value}
                            onChange={onChangeBeneficiary}/>
                    </div>
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_CLABE_INTERBANK_TITLE}
                            id="postalCode"
                            pattern={/^[0-9]+$/}
                            required={true}
                            maxLength={18}
                            minLength={18}
                            hasError={showErrors}
                            labelError={clabe.error}
                            value={clabe.value}
                            onChange={onChangeClabe}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="row border-attention m-0 py-3 mb-4">
                            <div className="col-1 p-0 text-center">
                                <img src={AssetsManager('/assets/images/common/attention-icon.svg')}
                                     alt="Attention"/>
                            </div>
                            <div className="col-11 p-0 input-text-enabled">
                                {GROUP.GROUP_BANK_ACCOUNT_INFO}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col d-flex">
                        <FileUploader
                            id="dealerAccountStatusFile"
                            type={BankAccountFileType.DEALER_ACCOUNT_STATUS_TYPE}
                            section={null}
                            customClass="mr-2"
                            required={true}
                            multiple={false}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            label={GROUP.GROUP_DEALER_ACCOUNT_STATUS_LABEL}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, BankAccountFileType.DEALER_ACCOUNT_STATUS_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={accountFile}
                            hasError={this.state.showErrors}
                            labelError={' '}/>

                        <FileUploader
                            id="dealerOfficialIdentificationFile"
                            type={BankAccountFileType.DEALER_OFFICIAL_IDENTIFICATION_TYPE}
                            section={null}
                            customClass="mr-2"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={GROUP.GROUP_DEALER_OFFICIAL_IDENTIFICATION_LABEL}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, BankAccountFileType.DEALER_OFFICIAL_IDENTIFICATION_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={identificationFile}
                            hasError={this.state.showErrors}
                            labelError={' '}/>
                    </div>
                </div>
                <div className="row mb-6">
                    {showErrors && (dealerOfficialIdentificationFile.error || dealerAccountStatusFile.error) &&
                    <div className="col text-left form-text is-invalid">
                        <img className="ic mr-2" alt="warning"
                             src={AssetsManager('/assets/images/common/warning-icon.svg')}/>
                        {dealerOfficialIdentificationFile.error || dealerAccountStatusFile.error}
                    </div>}
                </div>
                <div className="col-12 pt-3 px-0 border-top">
                    <div className="d-flex justify-content-end">
                        <a className={`${btnStyle} text-secondary-lighten-5`}
                           onClick={() => onCancel()}>{GROUP.GROUP_CANCEL_LABEL}</a>
                        <a id="saveBtn" className={formHasNotError ? `${btnStyle} text-primary pr-0` :
                            `${btnStyle} text-secondary-lighten-5 pr-0`}
                                           onClick={this.onPressSave}>{GROUP.GROUP_SAVE_LABEL}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankAccountView;
